import React, { useState } from "react";
import { Box, Container } from "@mui/material";
import snsWebSdk from "@sumsub/websdk";
import useDebounceEffect from "ahooks/lib/useDebounceEffect";
import { getSumSubAccessToken } from "service/api";
import { useQuery } from "hooks/use-query";
const SumSubVerification = () => {
  const query = useQuery();
  const [theFlowName, setTheFlowName] = useState<string | null>(null);
  useDebounceEffect(
    () => {
      const flowName = query.get("flowName");
      if (flowName) {
        setTheFlowName(flowName);
        getSumSubAccessToken(flowName).then((response) => {
          const { result, token } = response;
          if (result && token) {
            launchWebSdk(token);
          }
        });
      }
    },
    [],
    {
      wait: 0,
    }
  );

  const launchWebSdk = (accessToken: string) => {
    let snsWebSdkInstance = snsWebSdk
      .init(accessToken, () => getNewAccessToken())

      .withOptions({ addViewportTag: false, adaptIframeHeight: true })
      .on("idCheck.onStepCompleted", (payload) => {
        console.log("onStepCompleted", payload);
      })
      .on("idCheck.onError", (error) => {
        console.log("onError", error);
      })
      .build();
    snsWebSdkInstance.launch("#sumsub-websdk-container");
  };

  const getNewAccessToken = async () => {
    const response = theFlowName
      ? await getSumSubAccessToken(theFlowName)
      : { token: "" };
    return Promise.resolve(response.token);
  };

  return (
    <Box
      display={"flex"}
      alignItems="center"
      justifyContent="center"
      sx={{ mt: 4 }}
    >
      <Container maxWidth="sm">
        <div id="sumsub-websdk-container"></div>
      </Container>
    </Box>
  );
};

export default SumSubVerification;
